import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@mui/material';
import { FrontendLeaderboardScore } from '@crazygames/graph-types/game/leaderboard-scores.type';
import { COLORS } from '../../../../../../../../common/Styleguide/Common/colors';

type ProcessScoreType = 'delete' | 'approve';

interface ProcessScoreDialogProps {
  type: ProcessScoreType;
  open: boolean;
  scoreToProcess: FrontendLeaderboardScore | null;
  scoreLabel: string;
  processing: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const getDialogTitle = (type: ProcessScoreType) => {
  switch (type) {
    case 'delete':
      return 'Confirm Delete';
    case 'approve':
      return 'Confirm Approve';
  }
};

const getDialogAction = (type: ProcessScoreType) => {
  switch (type) {
    case 'delete':
      return 'Delete';
    case 'approve':
      return 'Approve';
  }
};

const getConfirmButtonStyle = (type: ProcessScoreType) => {
  switch (type) {
    case 'delete':
      return { backgroundColor: COLORS.alert[100] };
    case 'approve':
      return { backgroundColor: COLORS.success[100], color: COLORS.black[50] };
  }
};

const ProcessScoreDialog: React.FC<ProcessScoreDialogProps> = ({
  type,
  open,
  scoreToProcess,
  scoreLabel,
  processing,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{getDialogTitle(type)}</DialogTitle>
      <DialogContent>
        Are you sure you want to {getDialogAction(type).toLowerCase()} the score{' '}
        <strong>
          {scoreToProcess?.userScore} {scoreLabel}
        </strong>{' '}
        for user <strong>{scoreToProcess?.username}</strong> (ID: {scoreToProcess?.userId})? This action cannot be undone.
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={processing}>
          Cancel
        </Button>
        <Button onClick={onConfirm} style={getConfirmButtonStyle(type)} variant="contained" disabled={processing}>
          {processing ? <CircularProgress size={20} sx={{ ml: 1 }} /> : getDialogAction(type)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProcessScoreDialog;
